import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Computer.svg",
  "use": "Computer.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Computer.svg\"><path d=\"M8.01,15.0208a5,5,0,0,1,5-5h38a5,5,0,0,1,5,5v25a5,5,0,0,1-5,5h-38a5,5,0,0,1-5-5Zm4,22a1,1,0,0,0,1,1h38a1,1,0,0,0,1-1v-22a1,1,0,0,0-1-1h-38a1,1,0,0,0-1,1Zm11,17a1,1,0,0,1-1-1,1.0711,1.0711,0,0,1,1-1c1.2284-.2086,2.4907-2.0632,3-4,.14-.5342.4477-1,1-1h10c.5524,0,.86.4658,1,1,.5092,1.9368,1.7715,3.7914,3,4a1.0715,1.0715,0,0,1,1,1,1,1,0,0,1-1,1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol